import { getStringHashCode26igk1bx568vk as getStringHashCode } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
var CreateSecretInputClass;
function CreateSecretInput() {
  if (CreateSecretInputClass === VOID) {
    class $ {
      constructor(partyId, description) {
        this.r6t_1 = partyId;
        this.s6t_1 = description;
      }
      toString() {
        return 'CreateSecretInput(partyId=' + this.r6t_1.toString() + ', description=' + this.s6t_1 + ')';
      }
      hashCode() {
        var result = this.r6t_1.hashCode();
        result = imul(result, 31) + getStringHashCode(this.s6t_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof CreateSecretInput()))
          return false;
        if (!this.r6t_1.equals(other.r6t_1))
          return false;
        if (!(this.s6t_1 === other.s6t_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'CreateSecretInput');
    CreateSecretInputClass = $;
  }
  return CreateSecretInputClass;
}
//region block: exports
export {
  CreateSecretInput as CreateSecretInput30co61ns422r9,
};
//endregion

//# sourceMappingURL=CreateSecretInput.mjs.map
